import React from "react";
import {
  Alert
} from "reactstrap";

function Notification (props){
  return (
    <Alert
      className="alert-with-icon"
      color= {props.color ? props.color : "danger"}
      fade={props.fade ? props.fade : false}
    >
      <span
        data-notify="icon"
        className= {props.icon ? props.icon : "fas fa-exclamation-triangle"}
      />
      <span data-notify="message">
        {props.message ? props.message : "warning message undefined."}
      </span>
    </Alert>
  );
}

export default Notification;